module.exports = __webpack_public_path__ + "static/media/mudey_rating1.f39c9daf.svg";